import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IFieldEditingProps } from './common';

@Component({
    selector: 'app-diploma-supplement-value-input',
    templateUrl: './value-input.component.html',
    styleUrls: ['./diploma-supplement.component.scss']
})
export class DiplomaSupplementValueInputComponent {
    @Input() props: IFieldEditingProps;
    @Output('valueChange') changeEvent = new EventEmitter<any>();

    change(value: any) {
        this.changeEvent.emit(value);
    }
}
